import './cancel-modal.scss';

import { notification } from 'antd';
import { useNavigate } from 'react-router';

import { CustomModal } from '@/components/Shared/Modal/CustomModal';
import { ROUTES } from '@/components/Shared/routes/routes';
import { Button } from '@/components/Shared/ui';
import { autoCreditApi } from '@/integrations/app.api/auto-credit.api';
import { handleError } from '@/services/handleError';
import { useAppDispatch, useAppSelector } from '@/store';
import { onSetFinancingStoreToInitialState } from '@/store/financingStep.slice';

import { getVehicleFormKey } from '../../../helpers/helpers';
import useAutoCredRequestId from '../../../hooks/useAutoCredRequestId';

interface IProps {
  isOpened: boolean;
  onClose: () => void;
}

const CancelModal: React.FC<IProps> = ({ isOpened, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { selectedBank } = useAppSelector((state) => state.financingStep);
  const { userInfo } = useAppSelector((state) => state.userInfo);

  const { requestId } = useAutoCredRequestId();

  const modalCancelHandler = async () => {
    if (!selectedBank || !userInfo) return;

    try {
      await autoCreditApi.cancelBankResponse(selectedBank.id);
      // Очищаем данные по транспортному средству
      sessionStorage.removeItem(getVehicleFormKey(userInfo.uuid, requestId));
      notification.success({
        title: 'Предложение успешно отклонено'
      });

      dispatch(onSetFinancingStoreToInitialState());
      onClose();
      navigate(ROUTES.autoCredit);
    } catch (error) {
      handleError(error, {
        customTitle: 'Произошла ошибка при отмене предложения'
      });
    }
  };

  return (
    <CustomModal
      editClass="financing-cancel-modal"
      title="Вы точно хотите отменить предложение?"
      isModalOpen={isOpened}
      handleOk={modalCancelHandler}
      handleCancel={() => onClose()}
      footer={[
        <Button key="back" onClick={() => onClose()}>
          Нет
        </Button>,
        <Button key="submit" variant="filled-red" onClick={modalCancelHandler}>
          Да, отменить
        </Button>
      ]}
    />
  );
};

export default CancelModal;
